export const GET_CURRENT_MEDIA_SHARE = "GET_CURRENT_MEDIA_SHARE";
export const SET_CURRENT_MEDIA_SHARE_STATUS = "SET_CURRENT_MEDIA_SHARE_STATUS";
export const UPDATE_CURRENT_MEDIA_SHARE = "UPDATE_CURRENT_MEDIA_SHARE_STATUS";
export const UPDATE_CURRENT_MEDIA_SHARE_OPENED = "UPDATE_CURRENT_MEDIA_SHARE_OPENED";
export const RESET_CURRENT_MEDIA_SHARE = "RESET_CURRENT_MEDIA_SHARE";
